module.exports = __webpack_public_path__ + "img/wiki-home-bg.68c1ef31.png";